<template>
	<div class="b-table-sticky-header">
		<b-table head-variant="light" class="sa-b-table" sticky-header striped hover stacked="lg"
			:items="magazzinoArticoliGiacenzaItems" :fields="articoliFields" selectable select-mode="single"
			@row-selected="onRowSelectedArticoliItems" :tbody-tr-class="rowClassCustom">
			<template #cell(index)="data">
				{{ data.index + 1 }}
			</template>
			<template #cell(matricoleLotti)="row">
				{{ row.item.gestioneMatricole ? "Gestione Matricole" : row.item.gestioneLottiScadenze ? "Gestione Lotti"
					: "Non Prevista" }}
			</template>
			<template #cell(umId)="row">
				{{ getDescrizioneMultiploUnitaMisura(row.item.umId) }}
			</template>
			<template #cell(actions)="row">
				<b-button v-if="row.item.gestioneLottiScadenze || row.item.gestioneMatricole" size="sm"
					v-b-tooltip.hover title="Info Matricole Lotti" variant="outline-info"
					@click="onClickInfoLottiMatricole(row)" class="mr-1 no-text">
					<font-awesome-icon icon="info"> </font-awesome-icon>
				</b-button>
			</template>
			<template #row-details>
				<div :class="{ 'sa-badge-insert': true, }">
					<div>
						<span class="sa-badge-label">Cod.Articolo:</span>
						<b-form-input class="sa-badge-data" v-model="lottoMatricola.codiceArticolo"></b-form-input>

					</div>
					<div>
						<span class="sa-badge-label">Lotto/Matricola:</span>
						<b-form-input class="sa-badge-data" v-model="lottoMatricola.lottoMatricola"></b-form-input>

					</div>
					<div>
						<span class="sa-badge-label">Qtn:</span>
						<b-form-input class="sa-badge-data" v-model="lottoMatricola.quantita"
							type="number"></b-form-input>
					</div>
					<div>
						<span class="sa-badge-label">Scadenza:</span>
						<date-picker format="DD/MM/YYYY" value-type="timestamp" class="sa-badge-data"
							v-model="lottoMatricola.dataOraScadenza" type="date"></date-picker>

					</div>
					<div>
						<span class="sa-badge-label">Produzione:</span>
						<date-picker format="DD/MM/YYYY" value-type="timestamp" class="sa-badge-data"
							v-model="lottoMatricola.dataOraProduzione" type="date"></date-picker>

					</div>
					<div style="height: 100% !important;">
						<b-button size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text"
							style="margin-right: 5px" @click="onAddLottoMatricola()">
							<b-icon icon="plus"></b-icon>
						</b-button>
					</div>
				</div>
				<hr />
				<div class="sa-badge-group-lotti">
					<div :class="{ 'sa-badge': true, 'sa-badge-ft-active-class': isBadgeActiveLotto(item), 'sa-badge-ft-disable-class': isDisabledSelezione(item) }"
						v-for="item, index of getListaMatricoleLotti()" :key="index" @click="onSelezionaLotto(item)">
						<div>
							<span class="sa-badge-label">Cod.Articolo:</span>
							<span class="sa-badge-data">{{ item.codiceArticolo }}</span>
							<hr />
						</div>
						<div>
							<span class="sa-badge-label">Lotto/Matricola:</span>
							<span class="sa-badge-data">{{ item.lottoMatricola }}</span>
							<hr />
						</div>
						<div>
							<span class="sa-badge-label">Qtn:</span>
							<span class="sa-badge-data">{{ item.quantita }}</span>
							<hr />
						</div>
						<div>
							<span class="sa-badge-label">Scadenza:</span>
							<span class="sa-badge-data">{{ formatDateTime(item.dataOraScadenza)
							}}</span>
							<hr />
						</div>
						<div>
							<span class="sa-badge-label">Produzione:</span>
							<span class="sa-badge-data">{{ formatDateTime(item.dataOraProduzione)
							}}</span>
							<hr />
						</div>
						<div style="text-align: end; align-content: end" v-if="operazione == 1">
							<b-button size="sm"
								variant="btn btn-outline-danger waves-effect waves-light width-sm no-text"
								style="margin-right: 5px" @click="onRemoveLottoScademza(index)">
								<b-icon icon="trash"></b-icon>
							</b-button>
						</div>
					</div>
				</div>
			</template>
		</b-table>


	</div>

</template>

<script>
import ContabilitaMixin from '../../contabilita/mixins/ContabilitaMixin';
import UtilityMixin from '../../utility/UtilityMixin';
import MagazzinoMixins from '../mixins/MagazzinoMixins';
import DatePicker from "vue2-datepicker";
export default {
	components: { DatePicker },
	mixins: [ContabilitaMixin, MagazzinoMixins, UtilityMixin],
	mounted() {
		this.getPresidio();
	},
	data() {
		return {
			presidio: {},
			operazione: 0,
			rigaDocumento: {
				lottiScadenze: []
			},
			filtro: {
				page: 1,
				forPage: 50
			},
			itemsDetails: {},
			arrays: {
				articolo: null,
				lottoMatricoleSelezionate: [
				]
			},
			lottoMatricola: {
				id: "-1",
				idArticolo: null,
				codiceArticolo: null,
				lottoMatricola: null,
				quantita: 1,
				dataOraScadenza: new Date().getTime(),
				dataOraProduzione: new Date().getTime(),
			},
		};
	},
	watch: {
		magazzinoArticoliGiacenzaRecordNumbers: function (params) {
			this.$emit("updateRowNumberGiacenza", params)

		},
	},
	computed: {
		isOperazioneScarico() {
			return this.operazione == "-1";
		}
	},
	methods: {
		setFiltroRigaDocumentoOperazione(filtro = null, rigaDocumento, operazione) {
			this.operazione = operazione;
			this.rigaDocumento = rigaDocumento;
			if (filtro) {
				this.filtro.page = filtro.page;
				this.filtro.forPage = filtro.forPage
			}
			this.loadData();
		},
		onModificaRow(rowSelezionata) {
			console.log(rowSelezionata);
			this.loadData();
		},
		onRowSelectedArticoliItems(item) {
			this.arrays.articolo = item;
			if (item[0]) {
				let articolo = item[0];

				this.isGestioneLottoMatricole = articolo.gestioneMatricole || articolo.gestioneLottiScadenze
				if (this.isGestioneLottoMatricole) {
					this.lottoMatricola.idArticolo = articolo.id;
					this.lottoMatricola.codiceArticolo = articolo.codiceArticolo;
					this.rigaDocumento.lottiScadenze = [];
					let filtro = {
						idArticolo: articolo.id,
						codiceStruttura: this.presidio.codiceStruttura
					}
					this.loadDataMatricoleLotti(filtro);
				}
			}
			this.$emit("onRowSelectedArticoliItems", item)
		},
		getDescrizioneMultiploUnitaMisura() { },
		onClickInfoLottiMatricole(row) {
			row.toggleDetails();
		},
		getListaMatricoleLotti() {
			if (this.operazione == -1) {
				return this.magazzinoArticoliLottiItems;
			} else {
				return this.rigaDocumento.lottiScadenze;
			}
		},
		onRemoveLottoScademza(index) {
			this.rigaDocumento.lottiScadenze.splice(index, 1);
			this.emitLottoMatricola();
		},

		loadData() {
			this.filtro.nomeArticolo = this.rigaDocumento.descrizione ? this.rigaDocumento.descrizione.toUpperCase() : "";
			this.filtro.codiceArticolo = this.rigaDocumento.codiceArticolo;
			this.filtro.codiceAzienda = this.presidio.codiceStruttura;
			this.magazzinoArticoliGiacenzeLoadData(this.filtro);
		},
		loadDataMatricoleLotti(filtro) {
			this.magazzinoArticoloLottiLoadResource(filtro);
		},
		getPresidio() {
			let tmpPresidio = window.localStorage.getItem("presidio");
			if (tmpPresidio) {
				this.presidio = JSON.parse(tmpPresidio);
			}
		},
		rowClassCustom(item, type) {
			if (!item || type !== 'row') return
			if (item.giacenza < 0) return 'articolo-row-giacenza-color-danger'
		},
		isDisabledSelezione(element) {
			return element.giacenza == 0;
		},
		isBadgeActiveLotto(item) {
			const index = this.arrays.lottoMatricoleSelezionate.findIndex((element) => element.lottoMatricola === item.lottoMatricola);
			return index == -1 ? false : true;
		},
		onAddLottoMatricola() {
			let validation = this.validazioneLottoMatricola();
			if (!validation.esito) {
				this.generaBtoast(validation);
				return;
			}
			if (this.lottoMatricola) {
				let matricolaLotto = JSON.parse(JSON.stringify(this.lottoMatricola));
				this.rigaDocumento.lottiScadenze.push(matricolaLotto);
				this.resetLottoMatricolaRiga();
			}
			this.emitLottoMatricola();
		},
		emitLottoMatricola() {
			this.$emit("onAddLottoMatricola", this.rigaDocumento.lottiScadenze);
		},

		resetLottoMatricolaRiga() {
			this.lottoMatricola = {
				id: "-1",
				idArticolo: null,
				codiceArticolo: null,
				lottoMatricola: null,
				quantita: 1,
				dataOraScadenza: new Date().getTime(),
				dataOraProduzione: new Date().getTime(),
			};
			if (this.rigaDocumento) {
				this.lottoMatricola.idArticolo = this.rigaDocumento.idArticolo;
				this.lottoMatricola.codiceArticolo = this.rigaDocumento.codiceArticolo;
			}
		},
		onSelezionaLotto(lottoMatricola) {
			if (this.operazione == -1) {
				if (this.isBadgeActiveLotto(lottoMatricola)) {
					const index = this.arrays.lottoMatricoleSelezionate.findIndex((element) => element.lottoMatricola === lottoMatricola.lottoMatricola);
					this.arrays.lottoMatricoleSelezionate.splice(index, 1);
				} else {
					if (lottoMatricola.giacenza > this.rigaDocumento.quantita) {
						this.$bvToast.toast("Non è possibile selezionare questo lotto", {
							title: "Attenzione!",
							autoHideDelay: 5000,
							variant: "danger",
						});
						return;
					}
					if (this.arrays.lottoMatricoleSelezionate.length < this.rigaDocumento.quantita) {
						this.arrays.lottoMatricoleSelezionate.push(lottoMatricola);
						this.$emit("onSelectedLottoMatricola", this.arrays.lottoMatricoleSelezionate);
					} else {
						this.$bvToast.toast(`Puoi selezionare al massimo ${this.rigaDocumento.quantita} righe`, {
							title: "Attenzione!",
							autoHideDelay: 5000,
							variant: "danger",
						});
					}
				}
			}
		},
		generaBtoast(validation) {
			let message = validation.msg.split("#");
			const h = this.$createElement;
			const vNodesMsg = h("ul", { style: "margin-left: -18px" }, []);
			message.forEach((element) => {
				if (element.trim() != "") {
					vNodesMsg.children.push({ tag: "li", text: element });
				}
			});
			this.$bvToast.toast([vNodesMsg], {
				title: "Attenzione!",
				autoHideDelay: 5000,
				variant: "danger",
			});
		},
		validazioneLottoMatricola() {
			let esito = true;
			let msg = "";
			let articoloSelezionato = this.arrays.articolo[0];
			if (articoloSelezionato) {
				if (articoloSelezionato.gestioneLottiScadenze) {
					if (this.lottoMatricola.dataOraProduzione >= this.lottoMatricola.dataOraScadenza) {
						msg += "Lotto Data Ora produzione non può essere superiore o uguale alla data scadenza. ! #";
						esito = false;
					}
				}
				if (this.lottoMatricola.lottoMatricola == null || this.lottoMatricola.lottoMatricola.trim() == "") {
					msg += articoloSelezionato.gestioneMatricole ? "Matricola " : " Lotto ";
					msg += " non valido/a ! #";
					esito = false;
				}
				if (this.lottoMatricola.quantita <= 0) {
					msg += articoloSelezionato.gestioneMatricole ? "Matricola " : " Lotto ";
					msg += " quantita non può essere 0 o inferiore. ! #";
					esito = false;
				}
			} else {
				msg += "Articolo non selezionato! #";
				esito = false;
			}
			if (this.rigaDocumento.lottiScadenze.length == 0) {
				if (this.lottoMatricola.quantita > this.rigaDocumento.quantita) {
					msg += articoloSelezionato.gestioneMatricole ? "Matricola " : " Lotto ";
					msg += " quantita non può essere superiore della quantita riga. ! #";
					esito = false;
				}
			}


			return { esito: esito, msg: msg };
		},

	},
};
</script>

<style scoped>
.sa-badge-group-lotti {
	display: flex;
	gap: 8px;
	flex-wrap: wrap;
	margin-top: 15px;
}

.sa-badge {
	flex: 1 1 400px;
	max-width: calc(25% - 8px);
}

.sa-badge-insert {
	display: flex;
	gap: 20px;
	width: 100%;
	align-items: flex-end;
	margin-bottom: 15px;
}

.sa-badge-insert>div {
	flex: 1;
	min-width: 0;
}

.sa-badge-insert .sa-badge-data {
	width: 100%;
}

.sa-badge:hover {
	transform: translateY(-2px);
	box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
	background-color: rgba(255, 255, 255, 0.651);
}

.sa-badge-ft-disable-class {
	background-color: var(--sa-data-text-color);
	cursor: not-allowed;
	border-left: 3px solid #a71d2a;
}

.sa-badge-ft-active-class {
	transform: translateY(-2px);
	box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
	border: 1px solid var(--bg-sidebar) !important;
	border-color: var(--bg-sidebar) !important;
	background-color: var(--bg-button-press-color);
}

.sa-badge-ft-active-class:hover {
	box-shadow: 0 2px 10px rgba(63, 63, 63, 0.2);
	border: 1px solid var(--bg-sidebar) !important;
	border-color: var(--bg-sidebar) !important;
	background-color: var(--bg-button-press-color);
}

.sa-badge-ft-disable-class:hover {
	transform: translateY(0px);
}
</style>
